import { connect } from 'react-redux';
import ForgotPage from './ForgotPage';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
// import { push } from 'react-router-redux';
import {
    saveNewPassword,
    saveConfirmPassword,
    doForgotPassword,
    getForgotUserName,
} from '../../actions/forgotAction';
import { handleCloseAlert } from 'src/actions/errorAction';

export const mapStateToProps = (state: AppState) => {
    return {
        newPassword: state.forgotPassword.newpassword,
        confirmPassword: state.forgotPassword.confirmpassword,

        typeLink: state.forgotPassword.typeLink,

        errorMessage: state.errorState.errorMessage,
        errorBar: state.errorState.errorBar,
        successMessage: state.errorState.successMessage,
        successBar: state.errorState.successBar
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onSubmit: () => {
            // dispatch(fetchCurrentUser);
            dispatch(doForgotPassword);
        },
        saveNewPassword: (newpassword: string) => {
            dispatch(saveNewPassword(newpassword));
        },
        saveConfirmPassword: (confirmpassword: string) => {
            dispatch(saveConfirmPassword(confirmpassword));
        },
        handleClose: () => {
            dispatch(handleCloseAlert);
        },
        onComponentDidMount: (userName: string, typeLink: string) => {
            dispatch(getForgotUserName(userName, typeLink));
        }
    };
};

const ForgotPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ForgotPage);

export default ForgotPageContainer;



// WEBPACK FOOTER //
// ./src/components/forgotPasswordPage/ForgotPageContainer.tsx